import { render } from "./WalletForm.vue?vue&type=template&id=9bfb8a9a"
import script from "./WalletForm.vue?vue&type=script&lang=js"
export * from "./WalletForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__